import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProductSubCategoryModel } from '../models/product.sub.category.model';
import { ProductCategoryService } from '../services/productcategory.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-procuctsubcategory',
  templateUrl: './productsubcategory.component.html',
  styleUrls: ['./productsubcategory.component.css']
})
export class ProductSubcategoryComponent implements OnInit {

  productCategoryid: string;
  public productSubCategories: ProductSubCategoryModel[] = [];
  baseUrl = environment.baseUrl;
  displayName:string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductCategoryService,
    private spinner: SpinnerService
  ) {

    this.productCategoryid = this.route.snapshot.params.id;
    this.displayName = decodeURI(this.route.snapshot.queryParams.name);

  }

  ngOnInit(): void {
    this.spinner.showSpinner();
    this.service.getProductSubCategoriesByProductCategoryId(this.productCategoryid)
      .subscribe(
        (data => {
          this.productSubCategories = data;
        }),
        (error => {
          console.log(error);
        })
      );
    this.spinner.hideSpinner();

  }

  encodeContent = function (data) {
    return encodeURIComponent(data);
  }

}
